import { setChangePlanData } from "../../../container/QBO_Accounting/qbo_AccountingHelper";

export const MANAGE_PLAN_ACTIONS = {
  CHANGE_SUBSCRIPTION: "CHANGE_SUBSCRIPTION",
  CANCEL_SUBSCRIPTION: "CANCEL_SUBSCRIPTION",
  REACTIVATE: "REACTIVATE",
};

export const handleChangeSubscription = (updateAppStateLocal, history, lang) => {
  updateAppStateLocal({
    accountSettingsSidebarOpen: false,
    changePlanMode: true,
  });
  setChangePlanData({ active: true });
  history.push(`/${lang}/qbo-accounting/pricing`);
};

export const handleCancelSubscription = (updateAppStateLocal) => {
  updateAppStateLocal({
    accountSettingsSidebarOpen: false,
    cancelSubscriptionModalOpen: true,
  });
};

export const handleReactivate = (updateAppStateLocal) => {
  updateAppStateLocal({
    accountSettingsSidebarOpen: false,
    reactivateModalOpen: true,
  });
};

const helper = {
  MANAGE_PLAN_ACTIONS,
  handleChangeSubscription,
  handleCancelSubscription,
  handleReactivate,
};

export default helper;
